import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, Input as MuiInput } from "@mui/material";
import { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useTheme } from "@mui/material/styles";
import useDebounce from "components/hooks/useDebounce";

const Input = styled(MuiInput)(({ theme }) => ({
  fontSize: theme.fontSize.md,
  fontWeight: theme.fontWeight[200],
  "&.MuiInputBase-root:before": {
    borderBottom: "none",
  },
  "&.MuiInputBase-root:hover:before": {
    borderBottom: "none",
  },
  "&.MuiInputBase-root:after": {
    borderBottom: "none",
  },
}));

const SearchBox = ({
  handleOnChange,
  placeholder,
  query,
  autoFocus,
  delay,
}) => {
  const theme = useTheme();
  const [value, setValue] = useState(query);
  const debounced_value = useDebounce(value, delay);

  useEffect(() => {
    setValue(query);
  }, [query]);

  useEffect(() => {
    handleOnChange(debounced_value);
  }, [debounced_value]);

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleClear = () => {
    setValue("");
  };

  return (
    <>
      <Input
        fullWidth
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        autoFocus={autoFocus}
        sx={{ borderBottom: `0.5px solid ${theme.palette_custom.darkBlue}` }}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        }
        endAdornment={
          value && (
            <InputAdornment position="end">
              <CloseIcon onClick={handleClear} />
            </InputAdornment>
          )
        }
      />
    </>
  );
};

export default SearchBox;
